export const mailApiEndpoint: string = "http://omuthiya.unicomms.app/mail_php/mail.php?";
